module.exports = __webpack_public_path__ + "static/references-b4c0f19e736107f3144e3a171b2a8b17.jpg";